import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-motivational-coaching-banner',
  templateUrl: './motivational-coaching-banner.component.html',
  styleUrls: ['./motivational-coaching-banner.component.scss']
})
export class MotivationalCoachingBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
